import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Axios from 'axios'
import qs from 'qs';
import JsonExcel from 'vue-json-excel'
import 'animate.css'
// import VueMatomo from 'vue-matomo'
import HighchartsVue from 'highcharts-vue'
import  locale  from '../node_modules/element-ui/lib/locale/lang/en'


Vue.use(HighchartsVue)

// Vue.use(VueMatomo, {
//   host: 'http://47.122.25.237:10081/',
//   siteId: 1,
//   trackerFileName: 'matomo',
//   // 根据router自动注册
//   router: router,
//   // // 是否需要在发送追踪信息之前请求许可
//   // // 默认false
//   requireConsent: false,
//   enableLinkTracking: true,
//   // // 是否追踪初始页面
//   // // 默认true
//   trackInitialView: false,
//   // // 最终的追踪js文件名
//   // // 默认 'piwik'
//   // eslint-disable-next-line no-dupe-keys
//   trackerFileName: 'matomo',
// });
// window._paq.push(['trackPageView']); //To track pageview

Vue.component('downloadExcel', JsonExcel)
Vue.prototype.$qs = qs

Vue.prototype.$axios = Axios    //全局注册，使用方法为:this.$axios


Vue.use(VueAxios, axios)

Vue.use(ElementUI, {locale})
Vue.config.productionTip = false

new Vue({
  router: router,
  store,
  render: h => h(App)
}).$mount('#app')
